var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAltArrowRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20954 3.94426C7.46113 3.72861 7.83991 3.75775 8.05556 4.00934L12.8556 9.60934C13.0482 9.83403 13.0482 10.1656 12.8556 10.3903L8.05556 15.9903C7.83991 16.2419 7.46113 16.271 7.20954 16.0554C6.95794 15.8397 6.9288 15.4609 7.14446 15.2093L11.6098 9.99982L7.14446 4.79029C6.9288 4.53869 6.95794 4.15991 7.20954 3.94426Z",
    fill: "#868381"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAltArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AltArrowRight.88a89f13.svg";
export { ForwardRef as ReactComponent };